export function Prototype(prototype) {
    return function (TargetComponent) {
        _.extend(TargetComponent.prototype, prototype);
    };
}



// WEBPACK FOOTER //
// ./shared/decorators/Prototype.js